import { render, staticRenderFns } from "./folder_image.vue?vue&type=template&id=87606c7e&"
import script from "./folder_image.vue?vue&type=script&lang=js&"
export * from "./folder_image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports